'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of wholesale order web
 */ const WholesaleOrderWeb = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "19.9531",
                y: "29.6289",
                width: "63.9459",
                height: "37.2432",
                rx: "3.51351",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.9531 60.1274V63.3579C19.9531 65.2983 21.5262 66.8714 23.4666 66.8714H80.3856C82.326 66.8714 83.8991 65.2983 83.8991 63.3579V60.1274H19.9531Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "42.1562",
                y: "66.8711",
                width: "19.6757",
                height: "6.04324",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "35.2734",
                y: "72.7734",
                width: "33.3081",
                height: "1.68649",
                rx: "0.843243",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "28",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.736434",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M37.2312 45.3269V44.5225C37.551 44.5225 37.8103 44.2633 37.8103 43.9435V43.7613C37.8103 43.3408 37.4695 43 37.049 43H33.2648C32.8444 43 32.5035 43.3408 32.5035 43.7613V43.9435C32.5035 44.2633 32.7628 44.5225 33.0826 44.5225V45.3387C32.7649 45.4548 32.4908 45.6635 32.2973 45.937C32.1038 46.2104 32.0001 46.5354 32 46.8684V51.8753C32 52.3142 32.3558 52.67 32.7947 52.67H37.5542C37.993 52.67 38.3488 52.3142 38.3488 51.8753V46.8692C38.3488 46.5299 38.2412 46.199 38.0409 45.9226C37.8406 45.6462 37.5576 45.4379 37.2312 45.3269Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "32.4531",
                y: "43",
                width: "5.35909",
                height: "1.52436",
                rx: "0.547176",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "64",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.736434",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "46",
                y: "41",
                width: "15",
                height: "13",
                rx: "0.736434",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M50 44.5039C50 44.2252 50.2252 44 50.5039 44H55.5426C55.8213 44 56.0465 44.2252 56.0465 44.5039V45.0078C56.0465 45.2865 55.8213 45.5116 55.5426 45.5116H50.5039C50.2252 45.5116 50 45.2865 50 45.0078V44.5039Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M50.5039 45.5117H55.5427V50.5505C55.5427 51.1063 55.0908 51.5582 54.5349 51.5582H51.5117C50.9558 51.5582 50.5039 51.1063 50.5039 50.5505V50.0466H52.2675C52.406 50.0466 52.5194 49.9332 52.5194 49.7947C52.5194 49.6561 52.406 49.5427 52.2675 49.5427H50.5039V48.535H52.2675C52.406 48.535 52.5194 48.4216 52.5194 48.283C52.5194 48.1445 52.406 48.0311 52.2675 48.0311H50.5039V47.0233H52.2675C52.406 47.0233 52.5194 46.91 52.5194 46.7714C52.5194 46.6328 52.406 46.5195 52.2675 46.5195H50.5039V45.5117Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M69.0027 50.3008C69.0027 49.6414 69.0025 48.982 69.0028 48.3226C69.0029 47.9853 69.1489 47.7196 69.4281 47.5213C69.5191 47.4567 69.6223 47.4144 69.7308 47.3843C69.9071 47.3352 69.9552 47.2761 69.9597 47.0999C69.9615 47.029 69.9601 46.958 69.9577 46.8871C69.9567 46.8552 69.9599 46.839 70.0016 46.8391C70.6446 46.8401 71.2876 46.8396 71.9306 46.8379C71.9731 46.8378 71.981 46.853 71.9791 46.8891C71.9755 46.9579 71.9759 47.0268 71.9743 47.0956C71.9703 47.2612 72.0203 47.3322 72.1847 47.3799C72.4984 47.4711 72.7251 47.6567 72.8558 47.9488C72.906 48.061 72.9303 48.1781 72.9302 48.301C72.9295 49.6533 72.9299 51.0055 72.9294 52.3578C72.9292 52.7079 72.6588 52.9757 72.2983 52.9766C71.4093 52.9787 70.5203 52.9813 69.6314 52.9752C69.2653 52.9727 69.0029 52.7079 69.0013 52.3542C68.9984 51.7219 69.0013 51.0896 69.0017 50.4573C69.0017 50.4052 69.0017 50.353 69.0017 50.3008C69.002 50.3008 69.0023 50.3008 69.0026 50.3008H69.0027Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M72.0961 45.4277H69.8468C69.7675 45.4277 69.7031 45.4899 69.7031 45.5667V46.6964C69.7031 46.7732 69.7675 46.8354 69.8468 46.8354H72.0961C72.1755 46.8354 72.2398 46.7732 72.2398 46.6964V45.5667C72.2398 45.4899 72.1755 45.4277 72.0961 45.4277Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.1719 45.4222C70.1733 45.4075 70.1722 45.399 70.175 45.3932C70.2763 45.1853 70.2828 44.9595 70.2791 44.7285C70.274 44.408 70.2749 44.0873 70.2804 43.7668C70.2866 43.4068 70.4947 43.1114 70.7931 43.025C71.0989 42.9365 71.4183 43.0882 71.5719 43.3967C71.6321 43.5175 71.6607 43.6487 71.6607 43.7881C71.6607 44.1708 71.6642 44.5536 71.6591 44.9362C71.6573 45.0751 71.6841 45.2005 71.7368 45.3223C71.7799 45.4217 71.779 45.4212 71.6802 45.4212C71.2119 45.4212 70.7437 45.4218 70.2754 45.4222C70.2414 45.4222 70.2075 45.4222 70.1719 45.4222Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.WholesaleOrderWeb = WholesaleOrderWeb;
//# sourceMappingURL=WholesaleOrderWeb.cjs.map
